import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from "@angular/router";
import { Observable, of } from "rxjs";
import { TermsConditionsPositionEnum } from "@core/enums/terms-conditions-position.enum";
import { parseRouteParamNumber } from "@core/utils/parse-route-param-number.util";
import { ManagementCourseTermsConditionsService } from "@shared/services/management-course-terms-conditions/management-course-terms-conditions.service";

export const EndCourseTermsConditionsGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
): Observable<boolean | UrlTree> => {
  const managementCourseTermsConditions: ManagementCourseTermsConditionsService = inject(
    ManagementCourseTermsConditionsService,
  );
  const router: Router = inject(Router);

  const courseId: number | null = parseRouteParamNumber(route, "courseId");

  if (!courseId || courseId < 0) return of(router.createUrlTree(["/catalogue"]));

  return managementCourseTermsConditions.runCourseTermsGuard$({
    courseId,
    termsPosition: TermsConditionsPositionEnum.END,
    route,
  });
};
